module.exports = __webpack_public_path__ + "static/media/planning-name.5d9ef1be.svg";